import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserClock,
  faSearch,
  faUserCheck,
  faMapMarkerAlt,
  faDoorOpen,
  faPaw,
  faCheckCircle,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { DELIVERY_STATUS } from "../../../config/constants";

// Map status to icons
const statusIcons = {
  requested: faUserClock,
  finding_walker: faSearch,
  walker_assigned: faUserCheck,
  heading_to_pickup: faMapMarkerAlt,
  picked_up: faDoorOpen,
  in_progress: faPaw,
  completed: faCheckCircle,
  cancelled: faTimesCircle,
};

const StatusMessage = ({ status, message, type = 'walk' }) => {
  const icon = statusIcons[status.toLowerCase()] || faUserClock;

  return (
    <div className="flex items-center p-4 rounded-lg shadow-lg bg-gradient-to-r from-primary to-secondary text-white mb-4">
      {/* Icon */}
      <FontAwesomeIcon icon={icon} className="text-white text-3xl mr-4" />

      {/* Message Content */}
      <div className="flex flex-col">
        <h3 className="text-lg font-semibold leading-tight">
          {type == 'walk' ? message : getDeliveryFirstStatusDescription(status)}
        </h3>
        <p className="text-sm font-light opacity-90">
          {type == 'walk' ? getStatusDescription(status) : getDeliveryStatusDescription(status)}
        </p>
      </div>
    </div>
  );
};

// Helper function to provide additional description based on status
const getStatusDescription = (status) => {
  switch (status) {
    case "requested":
      return "Your request has been received and will be processed shortly.";
    case "finding_walker":
      return "Searching for an available walker in your area.";
    case "walker_assigned":
      return "A walker has been assigned and is on their way.";
    case "heading_to_pickup":
      return "Your walker is heading to the pickup location.";
    case "picked_up":
      return "The walker is waiting outside.";
    case "in_progress":
      return "Your pet is currently on a walk with the walker.";
    case "completed":
      return "The walk has been completed successfully!";
    case "cancelled":
      return "The walk was cancelled.";
    default:
      return "Status information is currently unavailable.";
  }
};

// Helper function to provide additional description based on status
const getDeliveryFirstStatusDescription = (status) => {
  switch (status) {
    case DELIVERY_STATUS.REQUESTED:
      return "Sit tight! We're finding the best driver for your delivery.";
    case DELIVERY_STATUS.FINDING:
      return "Hang on, we’re on the lookout for a driver!";
    case DELIVERY_STATUS.ASSIGNED:
      return "Great news! A driver is assigned and heading to your location.";
    case DELIVERY_STATUS.HEADING_TO_PICKUP:
      return "Your driver is on the way to the pickup location!";
    case DELIVERY_STATUS.PICKUP_ARRIVED:
      return "Your driver has arrived at the pickup location.";
    case DELIVERY_STATUS.EN_ROUTE_TO_DROPOFF:
      return "Your driver is en route to the drop-off location!";
    case DELIVERY_STATUS.DROPOFF_ARRIVED:
      return "Your driver has arrived at the drop-off location.";
    case DELIVERY_STATUS.EN_ROUTE_RETURN:
      return "Your driver is bringing your pet back to the return location.";
    case DELIVERY_STATUS.RETURN_ARRIVED:
      return "Your driver has arrived back at the return location.";
    case DELIVERY_STATUS.COMPLETED:
      return "Delivery completed! Your pet is safely back home.";
    case DELIVERY_STATUS.CANCELLED:
      return "This delivery was cancelled. Please check details.";
    default:
      return "Status unknown. Please check back later.";
  }
};


// Helper function to provide additional description based on status
const getDeliveryStatusDescription = (status) => {
  switch (status) {
    case DELIVERY_STATUS.REQUESTED:
      return "Your delivery request has been received and will be processed shortly.";

    case DELIVERY_STATUS.FINDING:
      return "Searching for an available driver in your area.";

    case DELIVERY_STATUS.ASSIGNED:
      return "A driver has been assigned and is on their way.";

    case DELIVERY_STATUS.HEADING_TO_PICKUP:
      return "Your driver is heading to the pickup location.";

    case DELIVERY_STATUS.PICKUP_ARRIVED:
      return "Your driver has arrived at the pickup location.";

    case DELIVERY_STATUS.EN_ROUTE_TO_DROPOFF:
      return "Your driver is on the way to the drop-off location.";

    case DELIVERY_STATUS.DROPOFF_ARRIVED:
      return "Your driver has arrived at the drop-off location.";

    case DELIVERY_STATUS.EN_ROUTE_RETURN:
      return "Your driver is heading back to the return location.";

    case DELIVERY_STATUS.RETURN_ARRIVED:
      return "Your driver has arrived back at the return location.";

    case DELIVERY_STATUS.COMPLETED:
      return "The delivery has been completed successfully!";

    case DELIVERY_STATUS.CANCELLED:
      return "The delivery was cancelled.";

    default:
      return "Status information is currently unavailable.";
  }
}


export default StatusMessage;
